"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDataUri = function getDataUri(src, placeholder) {
  return new Promise(function (resolve, reject) {
    if (!src) return resolve();
    var img = new Image();
    img.crossOrigin = 'Anonymous';

    img.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;
      canvas.getContext('2d').drawImage(this, 0, 0);
      var dataUri = canvas.toDataURL('image/jpg');
      resolve(dataUri);
    };

    img.onerror = reject;
    img.src = src;
  });
};

var _default = getDataUri;
exports.default = _default;